import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

const initialState = {
  periodStart: moment().locale("en").subtract(7, "days").format("YYYY-MM-DD"),
  periodEnd: moment().locale("en").format("YYYY-MM-DD"),
  statisticType: 'DAILY_SALES',
  employee: null,
  category: null,
  categoryLabel: null,
  brand: null,
  productSkuBarcode: null,
  warehouse: null,
};

const saleFiltersSlice = createSlice({
  name: 'saleFilters',
  initialState,
  reducers: {
    setSaleFilters(_, action) {
      return action.payload;
    },
    updateSaleFilter(state, action) {
      const { key, value } = action.payload;
      state[key] = value;
    },
    resetSaleFilters() {
      return initialState;
    },
  },
});

export const {
  setSaleFilters,
  resetSaleFilters
} = saleFiltersSlice.actions;

export default saleFiltersSlice.reducer;